function formatBytes(bytes, decimals = 2) {
    if (!bytes || bytes <= 0)
        return '0 Bytes';
    const multiplier = 1024;
    const places = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const index = Math.floor(Math.log(bytes) / Math.log(multiplier));
    return `${parseFloat((bytes / Math.pow(multiplier, index)).toFixed(places))} ${sizes[index]}`;
}
export default formatBytes;
//# sourceMappingURL=format-bytes.js.map